import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarRead } from "./solar-read-retry"
import type { SolarProposalProductOfferingDto } from "../dto/solar-proposal-product-offering.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * The saved Finance Partner, Finance Program and design equipment, with the
 * locks the form opens with. The gateway never calls a provider for it.
 */
export default function useSolarProposalProductOffering(
  proposalId: string | undefined,
  options: {
    /** How long a cached read stands in for the server's; 0 checks again. */
    staleTime?: number
  } = {},
): UseQueryResult<SolarProposalProductOfferingDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.productOffering(proposalId ?? ``),
    queryFn: () => solarProposalService.getProductOffering(proposalId ?? ``),
    enabled: Boolean(proposalId),
    ...(options.staleTime === undefined ? {} : { staleTime: options.staleTime }),
    retry: retrySolarRead,
  })
}
